function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// TODO: This component can be refactored to remove redundant code
// once we can confirm that all Sage products use version 105.0.0^
let ScrollBlockManager = /*#__PURE__*/function () {
  function ScrollBlockManager() {
    _classCallCheck(this, ScrollBlockManager);
    _defineProperty(this, "components", void 0);
    _defineProperty(this, "originalValues", void 0);
    // Due to possibility of multiple carbon versions using it
    // it is necessary to maintain same structure in this global variable
    if (!window.__CARBON_INTERNALS_SCROLL_BLOCKERS) {
      window.__CARBON_INTERNALS_SCROLL_BLOCKERS = {
        components: {},
        // originalValues can be removed
        originalValues: [],
        restoreValues: null
      };
    }
    this.components = window.__CARBON_INTERNALS_SCROLL_BLOCKERS.components;
    // TODO: originalValues can be removed
    this.originalValues = window.__CARBON_INTERNALS_SCROLL_BLOCKERS.originalValues;
  }
  return _createClass(ScrollBlockManager, [{
    key: "registerComponent",
    value: function registerComponent(id) {
      this.components[id] = true;
    }
  }, {
    key: "unregisterComponent",
    value: function unregisterComponent(id) {
      delete this.components[id];
    }
  }, {
    key: "saveRestoreValuesCallback",
    value: function saveRestoreValuesCallback(callback) {
      /* istanbul ignore else */
      if (window.__CARBON_INTERNALS_SCROLL_BLOCKERS) {
        window.__CARBON_INTERNALS_SCROLL_BLOCKERS.restoreValues = callback;
      }
    }
  }, {
    key: "getRestoreValuesCallback",
    value: function getRestoreValuesCallback() {
      return window.__CARBON_INTERNALS_SCROLL_BLOCKERS?.restoreValues;
    }

    // TODO: saveOriginalValues can be removed
  }, {
    key: "saveOriginalValues",
    value: function saveOriginalValues(values) {
      this.originalValues.length = 0;
      this.originalValues.push(...values);
    }

    // TODO: getOriginalValues can be removed
  }, {
    key: "getOriginalValues",
    value: function getOriginalValues() {
      return this.originalValues;
    }
  }, {
    key: "isBlocked",
    value: function isBlocked() {
      return Object.entries(this.components).length !== 0;
    }
  }]);
}();
export default ScrollBlockManager;